var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCheckBoxOptionButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 14H18.6693",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.6654V9.33203",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5026 25.6654H17.5026C23.3359 25.6654 25.6693 23.332 25.6693 17.4987V10.4987C25.6693 4.66536 23.3359 2.33203 17.5026 2.33203H10.5026C4.66927 2.33203 2.33594 4.66536 2.33594 10.4987V17.4987C2.33594 23.332 4.66927 25.6654 10.5026 25.6654Z",
    stroke: "#8493B2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCheckBoxOptionButton);
export default __webpack_public_path__ + "static/media/addCheckBoxOptionButton.0a9165c98cf5ab22e2c6ebb939726406.svg";
export { ForwardRef as ReactComponent };